import { useTimerManager } from '@/composables/timer-manager';

export default {
  data() {
    return {
      defaultMenu: false,
      menu: false
    };
  },
  setup() {
    const { registerTimeout } = useTimerManager();
    return {
      registerTimeout,
    };
  },
  computed: {
    hasNoItems() {
      return this.flatItems.length === 0;
    },
    computedMenuProps() {
      return {
        openOnClick: this.hasNoItems,
        closeOnClick: false,
        value: this.defaultMenu,
        offsetY: true,
      };
    },
  },
  methods: {
    handleMenu(menu){
      this.search = null;
      this.menu = menu
    },
    handleNativeClick(){
      // workaround, otherwise treeview is not opened after refocus autocomplete
      this.registerTimeout(() => this.menu = true, 0);
    }
  }
};
